import React from 'react';

function LoginHeroSection(): JSX.Element {
  return (
    <div
      className="w-2/3"
      style={{
        backgroundImage: `url('/svg/binary_with_text.svg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
}

export default LoginHeroSection;
